import {Injectable} from '@angular/core';
import {map, take} from 'rxjs/operators';
import {
  GenericValidationActionModal,
  GenericValidationModalComponent,
} from '../components/generic-validation-modal/generic-validation-modal.component';
import {NbDialogService} from '@nebular/theme';
import {merge, Observable} from 'rxjs';
import {tap} from 'rxjs/internal/operators/tap';
import {TranslateService} from '@ngx-translate/core';

export interface ValidationModalOptions {
  title?: string;
  message?: string;
  confirm?: string;
  cancel?: string;
  showCancel?: boolean;
  cardClass?: string;
}

export interface GenericModalResponse {
  backdropClicked?: boolean,
}

export type ValidationModalResponse = GenericModalResponse & GenericValidationActionModal;

@Injectable({
  providedIn: 'root'
})
export class PvModalDialogService {

  constructor(private dialogService: NbDialogService, private translateService: TranslateService) {
  }

  public openValidationModal(option?: ValidationModalOptions): Observable<ValidationModalResponse> {
    const dialog = this.dialogService.open(GenericValidationModalComponent, { context: option });

    const backDropClicked$ = dialog.onBackdropClick.pipe(map(_ => ({ backdropClicked: true } as ValidationModalResponse)))
    const modalAction$ = dialog.componentRef.instance.actionClicked.pipe(map(v => v as ValidationModalResponse))
    return merge(backDropClicked$, modalAction$).pipe(take(1), tap(_ => dialog.close()))
  }

  public openAddressUsedModal() {
    this.openValidationModal({
      title: this.translateService.instant('admin.modules.places.services.place_address.address_used_title'),
      message: this.translateService.instant('admin.modules.places.services.place_address.address_used_message'),
      showCancel: false,
      cardClass: 'modal--small'
    }).pipe(take(1)).subscribe()
  }
}
